import * as React from 'react';

import { AddToCartSettingsQuery } from '@notino/shared/definitions/types';

import { BuyButton } from '../sharedComponents/BuyButton';

import {
  DescriptionWrapper,
  ContentWrapper,
  ModalButtonWrapper,
} from './styled';

interface IProductForProcessionalModalProps {
  description: JSX.Element | string;
  settings: AddToCartSettingsQuery['Settings'];
  productId: string;
  productCode: string;
}

export const SpecialAddToCartModal: React.FC<
  IProductForProcessionalModalProps
> = ({ description, settings, productId, productCode }) => {
  return (
    <ContentWrapper data-testid="special-add-to-cart-modal">
      <DescriptionWrapper>{description}</DescriptionWrapper>
      <ModalButtonWrapper>
        <BuyButton
          productId={productId}
          productCode={productCode}
          isSpecialProduct={true}
          isOnSpecialModal={true}
          Settings={settings}
          buttonType="button"
        />
      </ModalButtonWrapper>
    </ContentWrapper>
  );
};
